/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BodySaveStep3ApiOnboardingStep3PostAccessLevel } from './bodySaveStep3ApiOnboardingStep3PostAccessLevel';

export interface BodySaveStep3ApiOnboardingStep3Post {
  /**
     * @minLength 1
     * @maxLength 255
     */
  title: string;
  description?: string | null;
  access_level?: BodySaveStep3ApiOnboardingStep3PostAccessLevel;
  collaborator_ids?: string[];
  job_title?: string | null;
  cover?: Blob | null;
}
